import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { PainSection } from './components/PainSection';
import { RevelationSection } from './components/RevelationSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ValueStack } from './components/ValueStack';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', '1039227432607622');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-[#0a0e1a] text-slate-300 font-sans selection:bg-amber-500/30 selection:text-amber-200" data-id="element-0">
      <UrgencyBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <HookSection data-id="element-4" />
        <PainSection data-id="element-5" />
        <RevelationSection data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <ValueStack data-id="element-8" />
        <GuaranteeSection data-id="element-9" />
        <FAQSection data-id="element-10" />
        <FinalCTA data-id="element-11" />
      </main>

      <Footer data-id="element-12" />
    </div>;
}